/**
 * @generated SignedSource<<514d44335388c012a71353603aab0bdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectGroupList_user$data = {
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroup_user">;
  readonly " $fragmentType": "ProjectGroupList_user";
};
export type ProjectGroupList_user$key = {
  readonly " $data"?: ProjectGroupList_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupList_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectGroupList_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectGroup_user"
    }
  ],
  "type": "users",
  "abstractKey": null
};

(node as any).hash = "7c4bddbd75c12ba18e3f8ee01c5de133";

export default node;
